<template>
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm">
      <a class="navbar-brand" href="#">Note</a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link class="nav-link" exact :to="{ name: 'home' }"
              >Home</router-link
            >
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'pages.about' }"
              >About</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'pages.contact' }"
              >Contact</router-link
            >
          </li> -->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Note</a
            >
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link :to="{ name: 'notes.create' }" class="dropdown-item"
                >New Note</router-link
              >
              <router-link :to="{ name: 'notes.table' }" class="dropdown-item"
                >Table Note</router-link
              >
            </div>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Subject</a
            >
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link
                :to="{ name: 'subjects.create' }"
                class="dropdown-item"
                >New Subject</router-link
              >
              <router-link
                :to="{ name: 'subjects.table' }"
                class="dropdown-item"
                >Table Subject</router-link
              >
            </div>
          </li>
        </ul>
        <!-- <form class="form-inline my-2 my-lg-0">
          <input
            class="form-control mr-sm-2"
            type="search"
            placeholder="Search"
            aria-label="Search"
          />
          <button class="btn btn-outline-success my-2 my-sm-0" type="submit">
            Search
          </button>
        </form> -->
      </div>
    </nav>
  </div>
</template>

<script>
export default {};
</script>

